import React from "react";
import bg_banner from "../../assets/images/banner-bg.jpg";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import amrish from "../../assets/images/untitled-2_720.png";
import likeIcon from "../../assets/images/Home-banner-img.png";
import scope from "../../assets/images/home-banner-img1.png";
import review from "../../assets/images/banner-rating-img.png";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
const HomePageBanner = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.4 });
  return (
    <div
      className="relative w-full h-[1350px] md:h-[750px] lg:h-[800px] xl:h-[950px] flex justify-center items-center   bg-blue-700"
      style={{
        backgroundImage: `url(${bg_banner})`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
      }}
    >
      {/* lg and up: Centered */}
      <div className="absolute hidden lg:block left-1/2 bottom-0 transform -translate-x-1/2">
        <img src={amrish} className="w-[450px] xl:w-[600px]" alt="amrish" />
      </div>

      {/* md only: Right aligned */}
      <div className="absolute hidden md:block lg:hidden right-0 bottom-0">
        <img src={amrish} className="w-[350px]" alt="amrish" />
      </div>

      {/* below md: Centered */}
      <div className="absolute block md:hidden left-1/2 bottom-0 transform -translate-x-1/2">
        <img src={amrish} className="w-[300px]" alt="amrish" />
      </div>

      <div className="2xl:w-[93%] 3xl:w-[90%] 4xl:w-4/5 w-[95%] flex -mt-44 md:mt-0 lg:flex-row flex-col justify-between">
        <div className="lg:w-1/2 w-full md:pt-20 pt-8 xl:pt-0 text-center sm:text-left">
          <h1 className="font-outfit xl:block hidden xl:text-[6vw] 2xl:text-[96px] text-white font-bold leading-[100px] ">
            Medical & <br></br>Health Care <br></br> Solutions.
          </h1>
          <h1 className="font-outfit xl:hidden block text-[46px] lg:w-[400px] leading-[50px] text-white font-bold ">
            Medical & Health Care Solutions.
          </h1>
          <p className="text-xl mt-5 text-[#D4DFFB] xl:block hidden font-outfit font-normal">
            Caring is our calling. Changing Health Care for Good.<br></br> We’re
            here for life. Feel better.
          </p>
          <p className="text-lg mt-5 xl:hidden block lg:w-80 w-full text-[#D4DFFB] font-outfit font-normal">
            Caring is our calling. Changing Health Care for Good. We’re here for
            life. Feel better.
          </p>
          <div className="my-8  text-center sm:text-left">
            <a
              href="1"
              className="text-white font-outfit text-xl hover:text-black flex justify-center sm:justify-start font-bold items-center group "
            >
              Book An Appointment{" "}
              <span className="text-sm ml-6 group-hover:bg-white border-[1px] border-white rounded-full p-5  flex justify-center items-center xl:w-16 w-12 h-12 xl:h-16 text-white transition-all hover:duration-200 group-hover:text-black">
                <ArrowOutwardIcon className="text-sm" />
              </span>
            </a>
          </div>
        </div>
        <div className="lg:w-2/5 md:w-2/3 w-full lg:pt-20 xl:pt-0 flex  flex-col lg:items-center font-outfit">
          <div className="lg:pr-10 lg:pl-5 lg:py-5 xl:text-xl lg:text-sm text-lg text-white  font-normal  ">
            <p className="xl:border-l-2 pb-3 lg:pb-0 xl:border-white  text-center sm:text-left lg:ps-5">
              Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur excepteur sint occaecat
              cupidatat non proident.
            </p>
          </div>
          <div className="lg:pr-10 md:pl-5 py-5 text-xl  text-white flex md:flex-row flex-col md:gap-5 gap-8 items-center md:items-start font-normal  ">
            <div>
              <div className="p-[18px] rounded-full bg-[#203BE1] hover:bg-[#0F2349] transition-all hover:duration-200">
                <img
                  src={likeIcon}
                  alt="likebtn"
                  className="hover:-translate-y-3 transition-all hover:duration-500"
                />
              </div>
            </div>
            <div className=" text-center md:text-left">
              <div
                ref={ref}
                className="xl:text-[60px] md:text-5xl text-[60px] font-bold  xl:my-3"
              >
                {inView ? <CountUp end={98} duration={2} /> : ""}%
              </div>
              <p className="md:text-lg text-2xl font-bold my-3 pt-4  mt-1 xl:pt-1">
                Positive Reviews
              </p>
              <p className="text-[#D4DFFB] font-normal text-sm pt-0.5">
                From Our Clients
              </p>
            </div>
          </div>
          <div className="md:pr-10 md:pl-5 py-5 text-xl  text-white flex gap-5 md:flex-row flex-col justify-center items-center md:items-start  md:justigy-start lg:justify-end w-full relative  font-normal  ">
            <div className="p-1 xl:block hidden absolute py-3 pr-9  ps-5 bg-white rounded-[100px] -left-20 group">
              <img
                src={review}
                alt="review"
                className="group-hover:scale-90 transition-all group-hover:duration-200"
              />
              <span className="text-xs font-outfit text-black absolute right-12 top-11">
                32k Total Reviews
              </span>
            </div>
            <div className=" ">
              <div className="p-[18px] rounded-full bg-[#203BE1] hover:bg-[#0F2349] transition-all hover:duration-200">
                <img src={scope} alt="likebtn" />
              </div>
            </div>
            <div className="text-center md:text-left">
              <div ref={ref} className="xl:text-[60px]   md:text-5xl text-[60px]  font-bold  xl:my-3">
                
                {
                  inView ? <CountUp end={38} duration={2} /> : ""
                }+
              </div>
              <p className="md:text-lg text-2xl font-bold my-3 pt-4  mt-1 xl:pt-1">
                Experienced Doctors
              </p>
              <p className="text-[#D4DFFB] font-normal text-sm pt-0.5">
                Our Treatment Office
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageBanner;
